// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/big-logo-common.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper_header__TkGUL {
  position: absolute;
  top: 0;
  left: 0;
}
.wrapper_header__TkGUL path:not(:first-child) {
  fill: #000093;
}

.wrapper_auth__OhpgI {
  width: 100vw;
  height: 100vh;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;
  padding: 28px;
}

.wrapper_cover__MZ0vC {
  width: 60vw;
  height: calc(100vh - 56px);
  margin-right: 28px;
  background: #f5f5fe url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center bottom no-repeat;
  background-size: 100% auto;
  border-radius: 8px;
}

.wrapper_content__rOYgI {
  width: calc(100vw - 300px - 114px);
  max-width: 972px;
  padding: 80px 0 60px;
  margin-left: calc(50vw + 150px);
  transform: translateX(-50%);
  font-size: 14px;
  font-weight: 300;
  color: #3E3E50;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.wrapper_content__rOYgI h1 {
  width: 100%;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 12px;
}
.wrapper_content__rOYgI h2 {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 5px;
}

.wrapper_input__FrXVT, .wrapper_code__GY3m2 {
  margin-top: 16px;
  color: #3E3E50;
}
.wrapper_input__FrXVT label, .wrapper_code__GY3m2 label {
  padding: 0;
  font-size: 12px;
  font-weight: 300;
  color: #3E3E50;
}
.wrapper_input__FrXVT input, .wrapper_input__FrXVT textarea, .wrapper_code__GY3m2 input, .wrapper_code__GY3m2 textarea {
  width: 100%;
  color: #3E3E50;
  border-radius: 4px;
  border: 1px solid #C3C3C9;
}
.wrapper_input__FrXVT input:disabled, .wrapper_input__FrXVT textarea:disabled, .wrapper_code__GY3m2 input:disabled, .wrapper_code__GY3m2 textarea:disabled {
  color: #E0E0E3;
  border: 1px solid #E0E0E3;
  background: none;
}

.wrapper_code__GY3m2 span {
  color: #3E3E50;
  border-color: #C3C3C9;
}

.wrapper_disabled__psHM5 label {
  color: #E0E0E3 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/reporting/Wrapper/wrapper.module.scss","webpack://./src/components/reporting/styles/colors.scss","webpack://./src/components/reporting/styles/sizes.scss"],"names":[],"mappings":"AAGA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;AAkBJ;AAhBI;EACI,aCKG;ADaX;;AAdA;EACI,YAAA;EACA,aAAA;EACA,yBCfI;EDgBJ,aAAA;EACA,mBAAA;EACA,aAAA;AAiBJ;;AAdA;EACI,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,mFAAA;EACA,0BAAA;EACA,kBAAA;AAiBJ;;AAdA;EACI,kCAAA;EACA,gBAAA;EACA,oBAAA;EACA,+BAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,cCpCI;EDqCJ,aAAA;EACA,eAAA;EACA,SEpCS;AFqDb;AAfI;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBE1CK;AF2Db;AAdI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AAgBR;;AAZA;EACI,gBAAA;EACA,cCzDI;ADwER;AAbI;EACI,UAAA;EACA,eAAA;EACA,gBAAA;EACA,cC/DA;AD8ER;AAZI;EACI,WAAA;EACA,cCpEA;EDqEA,kBAAA;EACA,yBAAA;AAcR;AAZQ;EACI,cCtEJ;EDuEI,yBAAA;EACA,gBAAA;AAcZ;;AATA;EACI,cCjFI;EDkFJ,qBChFI;AD4FR;;AATA;EACI,yBAAA;AAYJ","sourcesContent":["@use 'components/reporting/styles/colors.scss';\n@use 'components/reporting/styles/sizes.scss';\n\n.header{\n    position: absolute;\n    top: 0;\n    left: 0;\n    \n    path:not(:first-child){\n        fill: colors.$blueLogo;\n    }\n}\n\n.auth {\n    width: 100vw;\n    height: 100vh;\n    background-color: colors.$light;\n    display: flex;\n    align-items: center;\n    padding: 28px;\n}\n\n.cover{\n    width: 60vw;\n    height: calc(100vh - 56px);\n    margin-right: 28px;\n    background: #f5f5fe url(../../../assets/big-logo-common.svg) center bottom no-repeat;\n    background-size: 100% auto;\n    border-radius: 8px;\n}\n\n.content{\n    width: calc(100vw - sizes.$nav-menu-width - 114px);\n    max-width: 972px;\n    padding: 80px 0 60px;\n    margin-left: calc(50vw + (sizes.$nav-menu-width/ 2));\n    transform: translateX(-50%);\n    font-size: 14px;\n    font-weight: 300;\n    color: colors.$grey1;\n    display: flex;\n    flex-wrap: wrap;\n    gap: sizes.$graphs-gap;\n\n    h1{\n        width: 100%;\n        font-size: 20px;\n        font-weight: 500;\n        margin-bottom: sizes.$graphs-gap;\n    }\n\n    h2{\n        font-size: 16px;\n        font-weight: 400;\n        margin-bottom: 5px;\n    }\n}\n\n.input, .code{\n    margin-top: 16px;\n    color: colors.$grey1;\n\n    label{\n        padding: 0;\n        font-size: 12px;\n        font-weight: 300;\n        color: colors.$grey1;\n    }\n\n    input,textarea{\n        width: 100%;\n        color: colors.$grey1;\n        border-radius: 4px;\n        border: 1px solid colors.$grey3;\n\n        &:disabled{\n            color: colors.$grey4;\n            border: 1px solid colors.$grey4;\n            background: none;\n        }\n    }\n}\n\n.code span{\n    color: colors.$grey1;\n    border-color: colors.$grey3;\n}\n\n.disabled label{\n    color: colors.$grey4!important;\n}","$dark: #121217;\n$light: #FFFFFF;\n\n$grey1: #3E3E50;\n$grey2: #838390;\n$grey3: #C3C3C9;\n$grey4: #E0E0E3;\n$grey5: #F9F9FA;\n\n$blue1: #00007A;\n$blue2: #0000C9;\n$blue3: #4343FF;\n$blue4: #8686FF;\n$blue5: #D8D8FF;\n$blueLogo: #000093;\n\n$orange1: #DA8200;\n$orange2: #FFA92C;\n$orange3: #FFC26B;\n$orange4: #FFE1B7;\n$orange5: #FFF3E3;\n\n$green1: #033E0F;\n$green2: #218214;\n$green3: #58B441;\n$green4: #89D96B;\n$green5: #E1F8CE;\n\n$brick1: #7D1F01;\n$brick2: #B94402;\n$brick3: #E78D3D;\n$brick4: #FBD298;\n$brick5: #FDEBCB;\n\n$red1: #540726;\n$red2: #7C1028;\n$red3: #BD454A;\n$red4: #F4ADA1;\n$red5: #F9D9CF;\n\n\n:export {\n    light: $light;\n    dark: $dark;\n    blue1: $blue1;\n    blue2: $blue2;\n    blue3: $blue3;\n    blue4: $blue4;\n    blue5: $blue5;\n    orange1: $orange1;\n    orange2: $orange2;\n    orange3: $orange3;\n    orange4: $orange4;\n    orange5: $orange5;\n    grey1: $grey1;\n    grey2: $grey2;\n    grey3: $grey3;\n    grey4: $grey4;\n    grey5: $grey5;\n}","$breakpoint-sm: 600px;\n$breakpoint-md: 900px;\n$breakpoint-extra-lg: 2048px;\n\n$nav-menu-width: 300px;\n\n$graphs-gap: 12px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"light": `#FFFFFF`,
	"dark": `#121217`,
	"blue1": `#00007A`,
	"blue2": `#0000C9`,
	"blue3": `#4343FF`,
	"blue4": `#8686FF`,
	"blue5": `#D8D8FF`,
	"orange1": `#DA8200`,
	"orange2": `#FFA92C`,
	"orange3": `#FFC26B`,
	"orange4": `#FFE1B7`,
	"orange5": `#FFF3E3`,
	"grey1": `#3E3E50`,
	"grey2": `#838390`,
	"grey3": `#C3C3C9`,
	"grey4": `#E0E0E3`,
	"grey5": `#F9F9FA`,
	"header": `wrapper_header__TkGUL`,
	"auth": `wrapper_auth__OhpgI`,
	"cover": `wrapper_cover__MZ0vC`,
	"content": `wrapper_content__rOYgI`,
	"input": `wrapper_input__FrXVT`,
	"code": `wrapper_code__GY3m2`,
	"disabled": `wrapper_disabled__psHM5`
};
export default ___CSS_LOADER_EXPORT___;
